"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var WeightingBar_meta_1 = require("./WeightingBar.meta");

var mobx_1 = require("mobx");

var WeightingBlock_1 = __importDefault(require("./styledComponents/WeightingBlock"));

var Translate_1 = __importDefault(require("../Translate"));

var Translate_2 = require("../Translate/Translate");

var WeightingBar =
/** @class */
function (_super) {
  __extends(WeightingBar, _super);

  function WeightingBar(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = WeightingBar_meta_1.WEIGHTING_BAR_CATEGORY_KEY;
    _this.componentKey = WeightingBar_meta_1.WEIGHTING_BAR_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(WeightingBar.prototype, "weightingBlocks", {
    get: function get() {
      var _this = this;

      var weightingBlocks = this.props.weightingBlocks;
      return weightingBlocks.map(function (block) {
        var value = block.value,
            fontColor = block.fontColor,
            backgroundColor = block.backgroundColor,
            ariaLabel = block.ariaLabel,
            describedById = block.describedById;
        var ariaLabelText = ariaLabel;

        if (_this.translationContext && ariaLabelText) {
          ariaLabelText = _this.translationContext.translate(ariaLabelText);
        }

        return react_1.default.createElement(WeightingBlock_1.default, {
          "aria-label": ariaLabelText,
          "aria-describedBy": describedById,
          style: {
            backgroundColor: backgroundColor,
            color: fontColor
          }
        }, react_1.default.createElement(Translate_1.default, null, value));
      });
    },
    enumerable: true,
    configurable: true
  });

  WeightingBar.prototype.render = function () {
    var _this = this;

    var className = this.props.className;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(Translate_2.TranslationContext.Consumer, null, function (translationContext) {
      _this.translationContext = translationContext;
      return _this.weightingBlocks;
    }));
  };

  __decorate([mobx_1.computed], WeightingBar.prototype, "weightingBlocks", null);

  WeightingBar = __decorate([mobx_react_1.observer], WeightingBar);
  return WeightingBar;
}(shared_1.ComponentBase);

exports.WeightingBar = WeightingBar;
exports.default = shared_1.InjectedStyledComponent(WeightingBar, WeightingBar_meta_1.WEIGHTING_BAR_CATEGORY_KEY, WeightingBar_meta_1.WEIGHTING_BAR_COMPONENT_KEY);